module.exports = __webpack_public_path__ + "img/logo-eurostat.eda2c974.jpg";